import { ThemeText } from "@/components/Theme/ThemeText";

export function heading1_parser(node, children, parent, styles) {
    return (
        <ThemeText key={node.key} mt={15} mb={15} aria-level={1} role="heading" variant={'lg'}>
            {children}
        </ThemeText>
    );
}
export function heading2_parser(node, children, parent, styles) {
    return (
        <ThemeText key={node.key} mt={15} mb={15} aria-level={2} role="heading" variant={'md'}>
            {children}
        </ThemeText>
    );
}
export function heading3_parser(node, children, parent, styles) {
    return (
        <ThemeText key={node.key} mt={15} mb={15} aria-level={3} role="heading" variant={'sm'}>
            {children}
        </ThemeText>
    );
}
export function heading4_parser(node, children, parent, styles) {
    return (
        <ThemeText key={node.key} mt={15} mb={15} aria-level={4} role="heading" variant={'xs'}>
            {children}
        </ThemeText>
    );
}
export function heading5_parser(node, children, parent, styles) {
    return (
        <ThemeText key={node.key} mt={15} mb={15} aria-level={5} role="heading" variant={'xxs'}>
            {children}
        </ThemeText>
    );
}